import { NgModule, Optional, SkipSelf } from '@angular/core';
import { combineEffectsWithProviders } from '@essent/common';
import { EffectsModule } from '@ngrx/effects';

import { getInsulationAddressCheckApi } from './get-insulation-address-check/get-insulation-address-check.config';
import { getSolarPanelsAddressCheckApi } from './get-solar-panels-address-check/get-solar-panels-address-check.config';
import { getStoreProductsApi } from './get-store-products';
import { postGenericFormSubmitApi } from './post-generic-form-submit';
import { postInsulationConfirmationApi } from './post-insulation-confirmation/post-insulation-confirmation.config';
import { postSolarPanelsConfirmationApi } from './post-solar-panels-confirmation/post-solar-panels-confirmation.config';
import { postStoreOrderApi } from './post-store-order';
import { getSolarPaybackApi } from './get-solar-payback';
import { getTimeslotsApi } from './get-timeslots';
import { postHeatpumpsLeadApi } from './post-heatpumps-lead';
import { postCreateLeadInsulationApi } from './post-create-lead-insulation';
import { postCreateLeadBoilerApi } from './post-create-lead-boiler';

const { EFFECTS, PROVIDERS } = combineEffectsWithProviders(
  getSolarPanelsAddressCheckApi,
  postSolarPanelsConfirmationApi,
  getInsulationAddressCheckApi,
  postInsulationConfirmationApi,
  getStoreProductsApi,
  postStoreOrderApi,
  postGenericFormSubmitApi,
  getSolarPaybackApi,
  postHeatpumpsLeadApi,
  getTimeslotsApi,
  postCreateLeadInsulationApi,
  postCreateLeadBoilerApi
);

@NgModule({
  imports: [EffectsModule.forFeature(EFFECTS)],
  providers: [...PROVIDERS],
})
export class TemporaryCoreModulesModule {
  public constructor(
    @Optional()
    @SkipSelf()
    parentModule: TemporaryCoreModulesModule
  ) {
    if (parentModule) {
      throw new Error('TemporaryCoreModulesModule is imported more than once.');
    }
  }
}
